import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { LoadingPanel } from "../../components/layout/Loading";
import { findAllAreaAssignDistributor } from "../areaAssignToDistributor/services/areaAssignToDistributor.services";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { Button } from "@progress/kendo-react-buttons";
import { compareTargetView } from "./services/target.services";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const OrderChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  useEffect(() => {
    formRenderProps.onChange("abcd", {
      value: "",
    });
  }, []);

  return null;
};

const TargetView: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = React.useRef<any>(null);
  const loading = useAppSelector((state) => state.retailerSalesOrder.loading);
  const SalesRepresentativeList = useAppSelector(
    (state) => state.salesrepresentative.SalesRepresentativeList
  );
  const DistributorList = useAppSelector(
    (state) => state.areaAssign.DistributorList
  );
  const [groupData, setGroupData] = useState<any>([]);
  const [initialValues, setInitialValues] = useState({});
  const [formKey, setFormKey] = useState(1);
  const [expanded, setExpanded] = React.useState<any>(0);
  useEffect(() => {
    dispatch(findAllAreaAssignDistributor());
    const initialValueObj = {
      from_date: "",
      to_date: "",
      sr_id: null,
      distributor_id: null,
      last_year_comparison: null,
      target: null,
    };
    setInitialValues(initialValueObj);
  }, []);
  useEffect(() => {
    setFormKey(formKey + 1);
  }, []);

  //   const handleViewTarget = async (formRenderProps: FormRenderProps) => {
  //     const from_date = formRenderProps.valueGetter("from_date");
  //     const to_date = formRenderProps.valueGetter("to_date");
  //     const sr_id = formRenderProps.valueGetter("sr_id");
  //     const distributor_id = formRenderProps.valueGetter("distributor_id");
  //     const last_year_compariso = formRenderProps.valueGetter(
  //       "last_year_compariso"
  //     );
  //     const target = formRenderProps.valueGetter("target");

  //     try {
  //       const payload = {
  //         from_date: from_date ? moment(from_date).format("YYYY-MM-DD") : "",
  //         to_date: to_date ? moment(to_date).format("YYYY-MM-DD") : "",
  //         sr_id: sr_id ? sr_id : null,
  //         distributor_id: distributor_id ? distributor_id : null,
  //         last_year_comparison: last_year_compariso ? last_year_compariso : null,
  //         target: target ? target : null,
  //       };
  //       const response = await dispatch(compareTargetView(payload));
  //       if (response?.meta?.requestStatus === "fulfilled") {
  //         setGroupData(response.payload.data);
  //       }
  //     } catch (error) {
  //       console.error("Error in handleSubmit:", error);
  //     }
  //   };

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        from_date: values?.from_date
          ? moment(values?.from_date).format("YYYY-MM-DD")
          : "",
        to_date: values?.to_date
          ? moment(values?.to_date).format("YYYY-MM-DD")
          : "",
        sr_id: values.sr_id ? values.sr_id : null,
        distributor_id: values.distributor_id ? values.distributor_id : null,
        last_year_comparison: values.last_year_compariso
          ? values.last_year_compariso
          : null,
        target: values.target ? values.target : null,
      };
      const response = await dispatch(compareTargetView(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        setGroupData(response.payload.data);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  const YEAR_DATA = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
  ];
  return (
    <Form
      key={formKey}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement
          style={{
            overflow: "scroll",
            scrollbarWidth: "none",
            boxShadow: "lightgray 0px 0px 10px",
            borderRadius: 10,
            background: "white",
          }}
        >
          <ShadowCard style={{ padding: 12, marginBottom: 10 }}>
            <GridLayout
              style={{ marginRight: 30 }}
              gap={{ rows: 0, cols: 10 }}
              cols={[
                { width: "33.33%" },
                { width: "33.33%" },
                { width: "33.33%" },
              ]}
            >
              <GridLayoutItem colSpan={3}>
                <Typography.h4>Target View</Typography.h4>
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  wrapperStyle={{ width: "100%" }}
                  name="from_date"
                  label="From Date"
                  format={"dd/MM/yyyy"}
                  component={FormDatePicker}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  wrapperStyle={{ width: "100%" }}
                  name="to_date"
                  label="To Date"
                  format={"dd/MM/yyyy"}
                  minDate={
                    formRenderProps.valueGetter("from_date") ||
                    new Date(1900, 1, 1)
                  }
                  component={FormDatePicker}
                />
              </GridLayoutItem>
              <GridLayoutItem></GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="sr_id"
                  label="Sales Representative"
                  placeholder="Select Sales Representative"
                  component={FormSelectionField}
                  astrike={true}
                  validator={requiredValidator}
                  options={SalesRepresentativeList.map((emp: any) => ({
                    value: emp.id,
                    label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                  }))}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="distributor_id"
                  label="Distributor"
                  placeholder="Select Distributor"
                  component={FormSelectionField}
                  astrike={true}
                  validator={requiredValidator}
                  options={DistributorList.map((dis: any) => ({
                    value: dis.id,
                    label: dis.account_name,
                    // label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                  }))}
                />
              </GridLayoutItem>
              <GridLayoutItem></GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="last_year_comparison"
                  label="Last Year Comparison"
                  placeholder="Select Year"
                  component={FormSelectionField}
                  astrike={true}
                  validator={requiredValidator}
                  options={YEAR_DATA.map((year: any) => ({
                    value: year.value,
                    label: year.label,
                  }))}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="target"
                  label="Target %"
                  placeholder="Target"
                  max={100}
                  min={0}
                  component={FormNumericTextField}
                  astrike={true}
                  validator={requiredValidator}
                />
              </GridLayoutItem>

              <GridLayoutItem></GridLayoutItem>
              <GridLayoutItem
                colSpan={2}
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={"View"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 4 }}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
            <OrderChangeWatcher formRenderProps={formRenderProps} />
          </ShadowCard>
          <ShadowCard style={{ padding: 12, marginBottom: 10 }}>
            <GridLayout
              style={{ marginRight: 30 }}
              gap={{ rows: 0, cols: 10 }}
              cols={[
                { width: "33.33%" },
                { width: "33.33%" },
                { width: "33.33%" },
              ]}
            >
              <GridLayoutItem
                colSpan={3}
                style={{ overflow: "scroll", scrollbarWidth: "none" }}
              >
                <div
                  className="container-fluid orderform"
                  style={{ padding: "20px 0 0 0", minWidth: 800 }}
                >
                  <div className="row">
                    <div className="col-12">
                      <table
                        cellSpacing={1}
                        cellPadding={2}
                        className="table table-bordered w-100  salesorder-print-table"
                        style={{ marginTop: 1 }}
                      >
                        <tr
                          className="text-center fw-600 text-white bg-dark"
                          style={{ fontSize: 12 }}
                        >
                          {/* <th className="pb-3 pt-3" style={{ width: "5%" }}>
                            No.
                          </th> */}
                          <th className="pb-3 pt-3" style={{ width: "30%" }}>
                            Item Name
                          </th>
                          <th style={{ width: "10%" }}>Unit</th>
                          <th style={{ width: "10%", minWidth: 110 }}>MRP</th>
                          <th style={{ width: "10%", minWidth: 110 }}>
                            Previous Year 2 QTY
                          </th>
                          <th style={{ width: "15%", minWidth: 110 }}>
                            Previous Year 2 Value
                          </th>
                          <th style={{ width: "10%", minWidth: 110 }}>
                            Previous Year 1 QTY
                          </th>
                          <th style={{ width: "15%", minWidth: 110 }}>
                            Previous Year 1 Value
                          </th>
                          <th style={{ width: "10%", minWidth: 110 }}>
                            Target QTY
                          </th>
                          <th style={{ width: "10%", minWidth: 110 }}>
                            Target Value
                          </th>
                        </tr>
                        {groupData && groupData.length > 0 ? (
                          groupData?.map((item: any, mainIndex: number) => (
                            <tr key={mainIndex}>
                              <td colSpan={8} className="p-0">
                                <ExpansionPanel
                                  title={item?.item_group}
                                  expanded={expanded === mainIndex}
                                  tabIndex={0}
                                  key={item.id}
                                  onAction={(
                                    event: ExpansionPanelActionEvent
                                  ) => {
                                    setExpanded(
                                      event.expanded ? null : mainIndex
                                    );
                                  }}
                                >
                                  <Reveal>
                                    {expanded === mainIndex && (
                                      <ExpansionPanelContent className="sales-order-hover-class">
                                        {item?.item_margin_rate &&
                                          item?.item_margin_rate?.length > 0 &&
                                          item?.item_margin_rate?.map(
                                            (
                                              subitem: any,
                                              subIndex: number
                                            ) => (
                                              <div
                                                key={subIndex}
                                                id={`collapse${mainIndex}`}
                                              >
                                                <div
                                                  style={{
                                                    padding: "5px 0",
                                                  }}
                                                >
                                                  <table
                                                    style={{
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          width: "5%",
                                                        }}
                                                        className="text-center"
                                                      >
                                                        {subIndex + 1}
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "35%",
                                                        }}
                                                      >
                                                        {subitem?.product_name}
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Rs. {subitem?.mrp || 0}
                                                      </td>

                                                      <td
                                                        style={{
                                                          width: "10%",
                                                        }}
                                                      >
                                                        {subitem?.unit_code}
                                                      </td>

                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          padding: "0 5px",
                                                          minWidth: 150,
                                                        }}
                                                      >
                                                        <Field
                                                          wrapperClassName="right-alighned-field orderform-amount"
                                                          wrapperStyle={{
                                                            margin: 0,
                                                          }}
                                                          name={`amount_${item?.item_group_id}_${subitem?.item_id}`}
                                                          placeholder="0"
                                                          format="n2"
                                                          disabled={true}
                                                          component={
                                                            FormNumericTextField
                                                          }
                                                        />
                                                      </td>
                                                      <td
                                                        style={{
                                                          width: "10%",
                                                          padding: "0 5px",
                                                          minWidth: 150,
                                                        }}
                                                      >
                                                        <Field
                                                          wrapperClassName="right-alighned-field orderform-amount"
                                                          wrapperStyle={{
                                                            margin: 0,
                                                          }}
                                                          name={`amount_${item?.item_group_id}_${subitem?.item_id}`}
                                                          placeholder="0"
                                                          format="n2"
                                                          disabled={true}
                                                          component={
                                                            FormNumericTextField
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </ExpansionPanelContent>
                                    )}
                                  </Reveal>
                                </ExpansionPanel>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={8} className="text-center p-2">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </GridLayoutItem>
            </GridLayout>
          </ShadowCard>
        </FormElement>
      )}
    />
  );
};

export default TargetView;
